import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["spinnerSize", "height", "width", "color"],
  _excluded2 = ["height", "width", "isLeftAligned", "useExactDimensions"];
var __jsx = React.createElement;
import React from 'react';
import styled, { css } from 'styled-components';
import { ClipLoader } from 'react-spinners';
import { Flex } from 'rebass/styled-components';
export function FullPageLoader(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#61a58b' : _ref$color;
  return __jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    style: {
      height: '50vh',
      minHeight: '700px'
    }
  }, __jsx(ClipLoader, {
    color: color,
    size: 100
  }));
}

/**
 * @type {JSX.Element}
 *
 */
export function SmallLoader(_ref2) {
  var _ref2$spinnerSize = _ref2.spinnerSize,
    spinnerSize = _ref2$spinnerSize === void 0 ? null : _ref2$spinnerSize,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 60 : _ref2$height,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? null : _ref2$width,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? '#61a58b' : _ref2$color,
    props = _objectWithoutProperties(_ref2, _excluded);
  return __jsx(Container, _extends({
    height: height,
    width: width
  }, props), __jsx(ClipLoader, {
    color: color,
    size: spinnerSize || height
  }));
}

/**
 * @param {Object} props - Component props
 * @param {number} [props.height=60] - Height of the skeleton in pixels
 * @param {number|null} [props.width=null] - Width of the skeleton in pixels. If null, defaults to 100%
 * @param {boolean} [props.isLeftAligned=false] - Whether to align the skeleton to the left
 * @param {boolean} [props.useExactDimensions=false] - Whether to use the exact dimensions of the skeleton
 * @param {Object} [props...rest] - Additional props are spread to the container element
 * @returns {JSX.Element} A skeleton loader component with animation
 */
export function SkeletonLoader(_ref3) {
  var _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? 60 : _ref3$height,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? null : _ref3$width,
    _ref3$isLeftAligned = _ref3.isLeftAligned,
    isLeftAligned = _ref3$isLeftAligned === void 0 ? false : _ref3$isLeftAligned,
    _ref3$useExactDimensi = _ref3.useExactDimensions,
    useExactDimensions = _ref3$useExactDimensi === void 0 ? false : _ref3$useExactDimensi,
    props = _objectWithoutProperties(_ref3, _excluded2);
  return __jsx(Container, _extends({
    className: "skeleton-loading",
    height: height,
    width: width,
    $isLeftAligned: isLeftAligned,
    $useExactDimensions: useExactDimensions
  }, props), __jsx(Skeleton, {
    $isLeftAligned: isLeftAligned,
    $useExactDimensions: useExactDimensions
  }));
}
var Container = styled(Flex).withConfig({
  displayName: "loading__Container",
  componentId: "sc-4qi697-0"
})(["width:", ";height:", ";display:flex;justify-content:", ";align-items:center;.skeleton-loading{padding:0;justify-content:flex-end;align-items:flex-start;}"], function (_ref4) {
  var width = _ref4.width;
  return width ? "".concat(width, "px") : '100%';
}, function (_ref5) {
  var height = _ref5.height,
    $useExactDimensions = _ref5.$useExactDimensions;
  return $useExactDimensions ? "".concat(height, "px") : "".concat(height - 10, "px");
}, function (_ref6) {
  var $isLeftAligned = _ref6.$isLeftAligned;
  return $isLeftAligned ? 'flex-start' : 'center';
});
var Skeleton = styled.div.withConfig({
  displayName: "loading__Skeleton",
  componentId: "sc-4qi697-1"
})(["height:", ";width:", ";animation:skeleton-loading 1s linear infinite alternate;background-color:", ";border-radius:4px;", ";@keyframes skeleton-loading{0%{background-color:hsl(200,0%,90%);}100%{background-color:hsl(200,0%,70%);}}"], function (_ref7) {
  var $useExactDimensions = _ref7.$useExactDimensions;
  return $useExactDimensions ? '100%' : '75%';
}, function (_ref8) {
  var $useExactDimensions = _ref8.$useExactDimensions;
  return $useExactDimensions ? '100%' : '50%';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grey[95];
}, function (_ref10) {
  var $isLeftAligned = _ref10.$isLeftAligned;
  return !$isLeftAligned && css(["margin-left:auto;"]);
});